import { Search, Users, Star } from 'lucide-react';
import { FormattedMessage, defineMessages } from 'react-intl';

const defaultMessages = defineMessages({
  'howItWorks.title': {
    id: 'howItWorks.title',
    defaultMessage: 'Как это работает',
  },
  'howItWorks.stepTitle.0': {
    id: 'howItWorks.stepTitle.0',
    defaultMessage: 'Поиск услуг',
  },
  'howItWorks.stepDescription.0': {
    id: 'howItWorks.stepDescription.0',
    defaultMessage:
      'Используйте фильтры для поиска нужного специалиста в вашем городе',
  },
  'howItWorks.stepTitle.1': {
    id: 'howItWorks.stepTitle.1',
    defaultMessage: 'Связь со специалистом',
  },
  'howItWorks.stepDescription.1': {
    id: 'howItWorks.stepDescription.1',
    defaultMessage: 'Общайтесь напрямую и обсуждайте детали заказа',
  },
  'howItWorks.stepTitle.2': {
    id: 'howItWorks.stepTitle.2',
    defaultMessage: 'Оставьте отзыв',
  },
  'howItWorks.stepDescription.2': {
    id: 'howItWorks.stepDescription.2',
    defaultMessage: 'Поделитесь своим опытом и помогите другим пользователям',
  },
});

const steps = [
  {
    icon: Search,
    title: <FormattedMessage {...defaultMessages['howItWorks.stepTitle.0']} />,
    description: (
      <FormattedMessage {...defaultMessages['howItWorks.stepDescription.0']} />
    ),
  },
  {
    icon: Users,
    title: <FormattedMessage {...defaultMessages['howItWorks.stepTitle.1']} />,
    description: (
      <FormattedMessage {...defaultMessages['howItWorks.stepDescription.1']} />
    ),
  },
  {
    icon: Star,
    title: <FormattedMessage {...defaultMessages['howItWorks.stepTitle.2']} />,
    description: (
      <FormattedMessage {...defaultMessages['howItWorks.stepDescription.2']} />
    ),
  },
];

export function HowItWorks() {
  return (
    <section className='py-20'>
      <div className='container mx-auto px-6'>
        <h2 className='text-3xl font-bold text-center mb-12'>
          <FormattedMessage {...defaultMessages['howItWorks.title']} />
        </h2>
        <div className='grid grid-cols-1 md:grid-cols-3 gap-12'>
          {steps.map((step, index) => (
            <div key={index} className='text-center'>
              <div className='text-blue-600 mb-4 flex justify-center'>
                <step.icon className='w-12 h-12' />
              </div>
              <h3 className='text-xl font-semibold mb-4'>{step.title}</h3>
              <p className='text-gray-600'>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
